import { useEffect, useState } from 'react';
import { createVideoPlayer, VideoView } from 'expo-video';
import { StyleSheet, View } from 'react-native';

const VideoSession = ({ sourceKey, style }) => {
	const [ player, setPlayer ] = useState( null );

	useEffect( () => {
		// Create after commit so discarded renders cannot own native players.
		const nextPlayer = createVideoPlayer( JSON.parse( sourceKey ) );
		nextPlayer.loop = true;
		nextPlayer.muted = true;
		nextPlayer.audioMixingMode = 'mixWithOthers';
		nextPlayer.play();
		setPlayer( nextPlayer );

		return () => {
			setPlayer( null );
			nextPlayer.release();
		};
	}, [ sourceKey ] );

	if( player === null ) {
		return <View style={[ styles.video, style ]} />;
	}

	return (
		<VideoView 
			style={[ styles.video, StyleSheet.flatten( style) ]} 
			player={ player } 
			removeClippedSubviews={ true }
			contentFit={ 'cover' }
			nativeControls={ false }
			playsInline
		/>
	)
}

const ThemedVideo = ({ source, style } = {} ) => {
	const sourceKey = JSON.stringify( source ?? null );

	// A new source needs a new native view as well as a new player. Do not
	// reuse a view whose previous player is being released during cleanup.
	return <VideoSession key={ sourceKey } sourceKey={ sourceKey } style={ style } />;
};

const styles = StyleSheet.create({
	video: {
		resizeMode: 'cover',
	}
})


export default ThemedVideo;
